<app-card-auth
    title="Új jelszó létrehozása"
    description="Kérjük, adja meg az új jelszavát."
>
    <create-password-form
        [signInLink]="defaultLink"
        [buttonLink]="buttonLink"
    ></create-password-form>
</app-card-auth>
